import { createAction } from '@reduxjs/toolkit'
import { STORE_RESET_ALL } from 'constants/store'

import { clear as contract } from 'modules/contract/stores/collecting.store'
import { clear as billCurrent } from 'modules/bill/stores/current.store'
import { clear as billList } from 'modules/bill/stores/list.store'

export function clearAfterCurrentCompanyChanges(dispatch: any) {
  dispatch(contract())
  dispatch(billCurrent())
  dispatch(billList())
}

export const resetState = createAction(STORE_RESET_ALL)
